<!--
  author：Zoufx
  description：角色 授权
  date：2020/9/3
-->
<template>
    <el-container>
        <el-drawer title="角色授权" :visible="permissionVisible" :before-close="handleClose" append-to-body
                   :wrapperClosable="false" @open="handleOpen">
            <div style="height: calc(100% - 71px);">
                <el-scrollbar class="drawer_scrollbar">
                    <el-row style="padding: 30px">
                        <el-tree :data="treeData" node-key="id" show-checkbox default-expand-all ref="tree"
                                 :default-checked-keys="defaultCheckedKeys"
                                 :props="defaultProps"
                                 />
                    </el-row>
                </el-scrollbar>
            </div>
            <el-row class="drawer_footer">
                <el-button type="primary" @click="submit" :disabled="$store.state.loading">确 定</el-button>
                <el-button @click="handleClose" :disabled="$store.state.loading">取 消</el-button>
            </el-row>
        </el-drawer>
    </el-container>
</template>

<script>
    export default {
        name: 'SysRolePermission',
        props: ['permissionVisible', 'treeData','treeDataNoChildrenIds', 'selRow'],
        data() {
            return {
                rolePermission: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                defaultCheckedKeys: [],
            }
        },
        watch: {
            rolePermission(n) {
                let checkIds = [];
                n.forEach(ele => {
                    //为了解决菜单子节点在全部选中状态下，新增菜单后因为上级菜单已经为选中状态，会把新增的菜单也显示为选中状态的问题；
                    if (this.treeDataNoChildrenIds.indexOf(ele.menuId) != -1) {
                        checkIds.push(ele.menuId);
                    }
                });
                this.$refs.tree.setCheckedKeys(checkIds);
            }
        },
        methods: {
            async getRolePermission(id) {
                let {obj} = await this.postRequest('/sysRole/findPermissionByRoleId', {id});
                this.rolePermission = obj;
            },
            async submit() {
                let checkMenuIds = [];
                let halfCheckMenuIds = [];
                this.$refs.tree.getCheckedKeys().forEach(id => checkMenuIds.push(id));
                this.$refs.tree.getHalfCheckedKeys().forEach(id => halfCheckMenuIds.push(id));
                let params = {
                    roleId: this.selRow.id,
                    checkMenuIds: checkMenuIds.toString(),
                    halfCheckMenuIds: halfCheckMenuIds.toString()
                };
                await this.postRequest('/sysRole/savePermissionByRoleId', params);
                this.handleClose();
                this.$emit('refreshList')
            },
            handleOpen() {
                this.$nextTick(() => {
                    if (!this.$refs.tree || !this.selRow || !this.selRow.id) return;
                    this.getRolePermission(this.selRow.id);
                })
            },
            handleClose() {
                this.$emit('update:permissionVisible', false)
            },
        }
    }
</script>

<style scoped>

</style>
